import React from 'react';

import { ExtendedForecastListItem } from '@futrli/views/processors/forecasts/forecastsList';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { useForecastActionItems } from '../../../../hooks/use-forecast-action-items';

interface MyForecastRowActionsProps {
  forecast: ExtendedForecastListItem;
}

export const MyForecastRowActions = ({ forecast }: MyForecastRowActionsProps) => {
  const items = useForecastActionItems({ forecast });

  return <ListingPageRowActions items={items} />;
};
